<template>
  <div class="sportello" v-loading="loading">

    <el-tabs v-model="tabActive" type="card" class="col-24" v-loading="loading" @tab-click="handleClick">
      <!-- VARIAZIONE DATI PERSONALI START -->
      <el-tab-pane>


        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.label.datiPers').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <div v-if="datiPersVar.inAttesa === '1'" class="tab-sportello row row-custom inAttesa">
          <div class="col-24">
            <span>{{ datiPersVar.inAttesaMsg }}</span>
          </div>
        </div>

        <div class="tab-sportello row row-custom">
          <div class="colonna col-24">
            <div class="row">
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area col-24 no-padding">
                    {{ $t('sportello.label.datiPers').toUpperCase() }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.btn.modifica') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-switch v-model="datiPersVar.switchModifica" active-color="#007c74" inactive-color="#cecece"
                      :disabled="datiPersVar.inAttesa === '1'">
                    </el-switch>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.statoCiv') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select v-model="datiPersVar.codStatoCiv" :disabled="!datiPersVar.switchModifica">
                      <el-option v-for="item in tbl_statoCiv" :key="item.codice" :label="item.descr"
                        :value="item.codice">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.tel1') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.tel1" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.tel2') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.tel2" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-sportello row row-custom">
          <div class="colonna col-24">

            <div class="row">
              <!-- RESIDENZA -->
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area col-24 no-padding">
                    {{ $t('sportello.label.residenza').toUpperCase() }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.place') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resLocalita" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.address') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resIn" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.codPrv') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resProv" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.codMun') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resCom" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.CAP') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resCap" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
              </div>

              <!-- DOMICILIO -->
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area col-24 no-padding">
                    {{ $t('sportello.label.domicilio').toUpperCase() }}
                    <icon v-if="datiPersVar.switchModifica" name="riv-copy" scale="1.2"
                      @click.native="copiaResidenza()"></icon>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.place') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domLocalita" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.address') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domIn" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.codPrv') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domProv" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.codMun') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domCom" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.CAP') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domCap" clearable
                      :disabled="!datiPersVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="action">
          <el-button class="WEB-button WEB-button-primary" v-if="datiPersVar.switchModifica" @click="saveVarAnag()">
            {{ $t('sportello.btn.salva') }}
          </el-button>
        </div>

        <!-- <diario v-if="tabActive === '0'" :trasferta="trasferta" :tbl_genSta="tbl_genSta"
                 :tbl_socFat="tbl_socFat"></diario> -->

      </el-tab-pane>
      <!-- VARIAZIONE DATI PERSONALI END -->

      <!-- VARIAZIONE DATI FAMILIARI START -->
      <el-tab-pane>
        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.label.varAnag').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <!--
        <el-table :data="datiFam" class="el-table_customize" v-if="datiFam.length > 0">
          <el-table-column header-align="center" align="center"
                           label=""
                           width="50">

            <template slot-scope="scope">
              <div class="data-wrapper">
                <el-tooltip class="item" effect="dark" :content="$t('sportello.msg.'+scope.row.inAttesa)"
                            placement="top-start">
                <icon name="riv-circle" :class="getStatoClass_dett(scope.row.inAttesa)"
                      scale="0.8"></icon>
                </el-tooltip>
              </div>
            </template>
</el-table-column>
<el-table-column header-align="center" align="center" :label="$t('sportello.label.parente')" width="100">

  <template slot-scope="scope">
              <div class="data-wrapper">
                {{ scope.row.tipo }}
              </div>
            </template>
</el-table-column>
<el-table-column header-align="center" align="center" :label="$t('sportello.label.nomeCompleto')">

  <template slot-scope="scope">
              <div class="data-wrapper">
                {{ scope.row.cognome}} {{ scope.row.nome }}
              </div>
            </template>
</el-table-column>
<el-table-column header-align="center" align="center" :label="$t('sportello.label.dataNascita')" width="150">

  <template slot-scope="scope">
              <div class="data-wrapper">
                {{ scope.row.dataNasc | formattaData}}
              </div>
            </template>
</el-table-column>
<el-table-column header-align="center" align="center" :label="$t('sportello.label.cFisc')" width="200">

  <template slot-scope="scope">
              <div class="data-wrapper">
                {{ scope.row.cFisc}}
              </div>
            </template>
</el-table-column>
<el-table-column header-align="center" align="center" :label="$t('sportello.label.invalidita')" width="250">

  <template slot-scope="scope">
              <div class="data-wrapper">
                {{ scope.row.invalido}}
              </div>
            </template>
</el-table-column>
<el-table-column header-align="center" align="center" :label="$t('sportello.label.aCarico')" width="250">

  <template slot-scope="scope">
              <div class="data-wrapper">
                {{ scope.row.aCarico}}
              </div>
            </template>
</el-table-column>

</el-table>
-->
        <div v-if="datiFamVar.inAttesa === '1'" class="tab-sportello row row-custom inAttesa">
          <div class="col-24">
            <span>{{ datiFamVar.inAttesaMsg }}</span>
          </div>
        </div>

        <div v-if="datiFamVar.inAttesa !== '1'" class="tab-sportello row row-custom">
          <div class="colonna col-24">
            <div class="row">
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.btn.modifica') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-switch v-model="datiFamVar.switchModifica" active-color="#007c74" inactive-color="#cecece"
                      :disabled="datiFamVar.inAttesa === '1'">
                    </el-switch>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.parente') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select v-model="datiFamVar.tipoFam" :disabled="!datiFamVar.switchModifica">
                      <el-option v-for="item in tbl_tipoFam" :key="item.codice" :label="item.descr"
                        :value="item.codice">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.nome') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiFamVar.nome" clearable :disabled="!datiFamVar.switchModifica"
                      autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.cognome') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiFamVar.cognome" clearable
                      :disabled="!datiFamVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.cognome2') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiFamVar.cognome2" clearable
                      :disabled="!datiFamVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.dataNascita') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-date-picker class="dt-picker" v-model="datiFamVar.dataNasc" type="date" format="dd/MM/yyyy"
                      value-format="yyyyMMdd" placeholder="" :disabled="!datiFamVar.switchModifica">
                    </el-date-picker>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.cFisc') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiFamVar.codFisc" clearable
                      :disabled="!datiFamVar.switchModifica" autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.invalidita') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select v-model="datiFamVar.invalid" :disabled="!datiFamVar.switchModifica">
                      <el-option v-for="item in tbl_statoInv" :key="item.codice" :label="item.descr"
                        :value="item.codice">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.aCarico') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select v-model="datiFamVar.carico" :disabled="!datiFamVar.switchModifica">
                      <el-option v-for="item in tbl_statoCar" :key="item.codice" :label="item.descr"
                        :value="item.codice">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.sesso') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select v-model="datiFamVar.sesso" :disabled="!datiFamVar.switchModifica">
                      <el-option v-for="item in tbl_sesso" :key="item.codice"
                        :label="$t('sportello.label.' + item.codice)" :value="item.codice">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="tab-sportello row row-custom">
          <div class="colonna col-24">
            <div v-for="(fam, index)  in datiFamVarList" :key="index" class="row">
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area-panel col-24 no-padding">
                    {{ $t('sportello.label.parente').toUpperCase() }} # {{ index + 1 }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.parente') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    {{ fam.tipo }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.nomeCompleto') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    {{ fam.cognome }} {{ fam.nome }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.dataNascita') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    {{ fam.dataNasc | formattaData }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.cFisc') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    {{ fam.cFisc }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.invalidita') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    {{ fam.invalido === '' ? $t('sportello.label.no') : fam.invalido }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.label.aCarico') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    {{ fam.aCarico }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="action">
          <el-button class="WEB-button WEB-button-primary" v-if="datiFamVar.switchModifica" @click="saveVarFam()">
            {{ $t('sportello.btn.salva') }}
          </el-button>
        </div>

      </el-tab-pane>
      <!-- VARIAZIONE DATI FAMILIARI END -->


      <!-- VISUALIZZA DATI PERSONALI START -->
      <el-tab-pane>
        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.label.datiAnag').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <el-collapse v-model="accordionActive" accordion>
          <el-collapse-item :title="$t('sportello.label.accordion1')" name="1">
            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.datiPers').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.statoCiv') }} (*)
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.codStatoCiv }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.tel1') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.tel1 }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.tel2') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.tel2 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">

                <div class="row">
                  <!-- RESIDENZA -->
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.residenza').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.place') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.resLocalita }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.address') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.resIn }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.codPrv') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.resProv }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.codMun') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.resCom }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.CAP') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.resCap }}
                      </div>
                    </div>
                  </div>

                  <!-- DOMICILIO -->
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.domicilio').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.place') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.domLocalita }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.address') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.domIn }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.codPrv') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.domProv }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.codMun') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.domCom }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.CAP') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiPers.domCap }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item :title="$t('sportello.label.accordion2')" name="2">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.numFigli') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiFam.length }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(fam, index)  in datiFam" class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.parente').toUpperCase() }} # {{ index + 1 }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.parente') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ fam.tipo }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.nomeCompleto') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ fam.cognome }} {{ fam.nome }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.dataNascita') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ fam.dataNasc | formattaData }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.cFisc') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ fam.cFisc }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.invalidita') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ fam.invalido === '' ? $t('sportello.label.no') : fam.invalido }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.aCarico') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ fam.aCarico }}
                      </div>
                    </div>


                  </div>


                </div>
              </div>
            </div>

          </el-collapse-item>
          <el-collapse-item :title="$t('sportello.label.accordion3')" name="3">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.anticipo').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.amortPrest') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.amortPrest) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.anticMese') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.anticMese) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.anticExtra') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.anticExtra) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.totMaturati').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.totDevengoPrec') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.totDevengoPrec) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.totDevengoAtt') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.totDevengoAtt) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.hWorked').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.oreLav') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ datiRet.oreLav }} {{ $t('sportello.label.hours') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.label.reddito').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.IRPFA') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.IRPFA) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.IRPFF') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.IRPFF) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.cotTrab') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.cotTrab) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.cotEmpr') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ formatEuro(datiRet.cotEmpr) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </el-collapse-item>
          <el-collapse-item :title="$t('sportello.label.accordion4')" name="4">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-md-11 col-12 no-padding">

                      </div>
                      <div class="my-area-panel col-md-6 col-6">
                        {{ $t('sportello.label.annoPrec').toUpperCase() }}
                      </div>
                      <div class="my-area-panel col-md-7 col-6">
                        {{ $t('sportello.label.annoAtt').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.maturato') }}
                      </div>
                      <div class="sportello-value col-md-6 col-6">
                        {{ formatDate(ferieRip.devengPrec) }}
                      </div>
                      <div class="sportello-value col-md-7 col-6">
                        {{ formatDate(ferieRip.devengAtt) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.prese') }}
                      </div>
                      <div class="sportello-value col-md-6 col-6">
                        {{ formatDate(ferieRip.disfrutPrec) }}
                      </div>
                      <div class="sportello-value col-md-7 col-6">
                        {{ formatDate(ferieRip.disfrutAtt) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.label.residuo') }}
                      </div>
                      <div class="sportello-value col-md-6 col-6">
                        {{ formatDate(ferieRip.pendienPrec) }}
                      </div>
                      <div class="sportello-value col-md-7 col-6">
                        {{ formatDate(ferieRip.pendienAtt) }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </el-collapse-item>
        </el-collapse>


      </el-tab-pane>
      <!-- VISUALIZZA DATI PERSONALI END -->


      <el-tab-pane>
        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.label.moduli').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <div class="tab-sportello row row-custom">
          <div class="colonna col-24">
            <div class="row">
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area-panel col-md-11 col-12 no-padding">
                    {{ $t('sportello.label.moduli').toUpperCase() }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="my-radio">
                    <el-radio-group v-model="modulo">
                      <el-radio v-for="item in moduli" :label="item.tipo" :key="item.tipo">{{ item.descrizione }}
                      </el-radio>

                    </el-radio-group>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="action">
          <el-button class="WEB-button WEB-button-primary" @click="ricModulo()">
            {{ $t('sportello.btn.salva') }}
          </el-button>
        </div>


        <!--<auto v-if="tabActive === '3'" :trasferta="trasferta" :tbl_genSta="tbl_genSta"></auto>-->
      </el-tab-pane>

    </el-tabs>

  </div>
</template>
<script>
export default {
  name: 'SportelloES',
  i18n: {
    messages: {
      it_IT: {},
      fr_FR: {},
      es_ES: {
        sportello: {
          label: {
            title: 'Ventanilla digital',
            datiPers: 'Datos personales',
            varAnag: 'Variaciones Parientes',
            datiAnag: 'Visualiza datos personales',
            moduli: 'Petición de datos personales',
            residenza: 'Residencia',
            domicilio: 'Domicilio',
            statoCiv: 'Estado Civil',
            tel1: 'Teléfono 1',
            tel2: 'Teléfono 2',
            place: 'Localidad',
            address: 'Dirección',
            codPrv: 'Cod. Provincia',
            codMun: 'Cod. Municipio',
            CAP: 'Codico Postal',
            accordion1: 'Datos anagráficas',
            accordion2: 'Parientes',
            accordion3: 'Datos retributivos',
            accordion4: 'Vacaciones',
            numFigli: 'Número de hijos a cargo',
            parente: 'Pariente',
            nomeCompleto: 'Nombre y apellidos',
            nome: 'Nombre',
            cognome: 'Apellidos',
            cognome2: 'Segundo Apellidos',
            dataNascita: 'Fecha Nacimiento',
            cFisc: 'N.I.F',
            invalidita: 'Invalidez',
            aCarico: 'A su cargo',
            sesso: 'Sexo',
            no: 'NO',
            anticipo: 'Anticipo a cuenta',
            amortPrest: 'Amortizacion Prestamos',
            anticMese: 'Anticipo mes',
            anticExtra: 'Anticipo pagas extras',
            totMaturati: 'Total devengo',
            totDevengoPrec: 'Total devengo año anterior',
            totDevengoAtt: 'Total devengo año actual',
            hWorked: 'Hora normales trabajadas año actual',
            oreLav: 'Hora normales trabajadas año actual',
            reddito: 'IRPF/Cotizacion S. Social (año actual)',
            IRPFA: 'IRPF A',
            IRPFF: 'IRPF F',
            cotTrab: 'Cotizacion trabajador',
            cotEmpr: 'Cotizacion empresa',
            euro: '€',
            hours: 'h',
            day: 'd',
            annoPrec: 'año anterior',
            annoAtt: 'año actual',
            V: 'HOMBRE',
            M: 'MUYESR',
            moduli: 'lista de módulos',
            maturato: 'Maturado',
            prese: 'Tomado',
            residuo: 'Residuo'
          },
          msg: {
            copiaTitle: 'Copia datos',
            copia: '¿Está seguro de copiar los datos del domicilio?',
            1: 'Dato en elaboracion de la ificina del personal',
            0: 'Aprobados',
            confirmRicModulo: '¿Está seguro de enviar la solicitud?'
          },
          btn: {
            modifica: 'modificación',
            salva: 'Guardar',
            confirm: 'Confirmación',
            abort: 'No'
          }
        }
      },
      de_DE: {
        sportello: {
          title: 'Ventanilla digital'
        }
      },
      en_GB: {
        sportello: {}
      }
    }
  },
  data() {
    return {
      loading: false,
      idTrasferta: '',
      tabActive: '-1',
      accordionActive: '1',
      tbl_statoCiv: [],
      tbl_tipoFam: [],
      tbl_statoCar: [],
      tbl_statoInv: [],
      tbl_sesso: [
        { codice: 'V' }, { codice: 'M' }
      ],
      trasferta: {},
      datiPersVar: {
        switchModifica: false,
        codStatoCiv: '',
        tel1: '',
        tel2: '',
        resLocalita: '',
        resIn: '',
        resProv: '',
        resCom: '',
        resCap: '',
        domLocalita: '',
        domIn: '',
        domProv: '',
        domCom: '',
        domCap: '',
        inAttesa: '',
        inAttesaMsg: ''
      },
      datiPers: {
        switchModifica: false,
        codStatoCiv: '',
        tel1: '',
        tel2: '',
        resLocalita: '',
        resIn: '',
        resProv: '',
        resCom: '',
        resCap: '',
        domLocalita: '',
        domIn: '',
        domProv: '',
        domCom: '',
        domCap: ''
      },
      datiFamVar: {
        switchModifica: false,
        tipoFam: '',
        nome: '',
        cognome: '',
        cognome2: '',
        dataNasc: '',
        codFisc: '',
        cFiscFam: '',
        invalid: '',
        carico: '',
        sesso: '',
        inAttesa: '',
        inAttesaMsg: ''
      },
      datiFamVarList: [],
      datiFam: [],
      datiRet: {
        IRPFA: '',
        IRPFF: '',
        cotTrab: '',
        cotEmpr: '',
        totDevengoPrec: '',
        totDevengoAtt: '',
        oreLav: '',
        amortPrest: '',
        anticMese: '',
        anticExtra: ''
      },
      ferieRip: {
        devengPrec: '',
        devengAtt: '',
        disfrutPrec: '',
        disfrutAtt: '',
        pendienPrec: '',
        pendienAtt: ''
      },
      numFiglio: 0,
      moduli: [],
      modulo: ''
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.loading = true
    this.tabActive = 0
    this.loadStatoCiv()
    this.loadTipoFam()
    this.loadTipoCar()
    this.loadTipoInv()
    this.loadVarAnag()
  },
  mounted: function () {
  },
  methods: {
    handleClick: function (tab, event) {
      if (tab.index === '1') {
        this.loadVarFam()
      } else if (tab.index === '2') {
        this.dataAnag()
        this.dataFam()
        this.loadDatiRet()
        this.loadFerieRip()
      } else if (tab.index === '3') {
        this.loadModuli()
      }
    },
    formatEuro: function (value) {
      return (value === '' ? '0,00' : value) + ' ' + this.$t('sportello.label.euro')
    },
    formatDate: function (value) {
      return (value === '' ? '0,00' : value) + ' ' + this.$t('sportello.label.day')
    },
    link: function (route) {
      this.$router.push({ name: route })
    },
    loadVarAnag: function () {
      this.loading = true
      this.$http.get('sportello/' + this.$store.state.country + '/varanag')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'datiPersVar', response.body.data)
            if (response.body.msg !== undefined) {
              this.datiPersVar.inAttesaMsg = response.body.msg[0].msgTxt
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    saveVarAnag: function () {
      this.loading = true
      let obj = JSON.parse(JSON.stringify(this.datiPersVar))
      delete obj['switchModifica']
      delete obj['co1ra']
      delete obj['co2dt']
      delete obj['co3dp']
      delete obj['statoCiv']
      delete obj['inAttesa']
      delete obj['inAttesaMsg']
      obj['tel1'] = obj.tel1 === '' ? '***' : obj.tel1
      obj['tel2'] = obj.tel2 === '' ? '***' : obj.tel2
      this.$http.post('sportello/' + this.$store.state.country + '/varanag', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loading = false
            this.loadVarAnag()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.loading = false
          }
        })
    },
    saveVarFam: function () {
      this.loading = true
      let obj = JSON.parse(JSON.stringify(this.datiFamVar))
      delete obj['switchModifica']
      this.$http.post('sportello/' + this.$store.state.country + '/varfam', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loading = false
            this.loadVarFam()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.loading = false
          }
        })
    },
    loadVarFam: function () {
      this.loading = true
      let obj = {
        switchModifica: false,
        tipoFam: '',
        nome: '',
        cognome: '',
        cognome2: '',
        dataNasc: '',
        codFisc: '',
        cFiscFam: '',
        invalid: '',
        carico: '',
        sesso: '',
        inAttesa: '',
        inAttesaMsg: ''
      }
      this.$set(this, 'datiFamVar', obj)
      this.$http.get('sportello/' + this.$store.state.country + '/varfam')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'datiFamVarList', response.body.data)
            for (let i = 0; i < response.body.data.length; i++) {
              if (response.body.data[i].inAttesa === "1") {
                this.datiFamVar.inAttesa = "1"
                if (response.body.msg !== undefined) {
                  this.datiFamVar.inAttesaMsg = response.body.msg[0].msgTxt
                }
              }
            }
            /* this.datiFam = response.body.data.filter(function (obj) {
              if (obj.inAttesa !== "0")
                return obj
            }) */
            //this.$set(this, 'datiFam', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadStatoCiv: function () {
      this.$http.get('dipendente/' + this.$store.state.country + '/listStatCiv')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_statoCiv = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadTipoFam: function () {
      this.$http.get('dipendente/' + this.$store.state.country + '/tipofam')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_tipoFam = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadTipoCar: function () {
      this.$http.get('dipendente/' + this.$store.state.country + '/tipocar')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_statoCar = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadTipoInv: function () {
      this.$http.get('dipendente/' + this.$store.state.country + '/tipoinv')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_statoInv = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    dataAnag: function () {
      this.loading = true
      this.$http.get('sportello/' + this.$store.state.country + '/anag')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'datiPers', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    dataFam: function () {
      this.loading = true
      this.$http.get('sportello/' + this.$store.state.country + '/fam')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'datiFam', response.body.data)

            this.numFiglio = response.body.attrib.numFigli
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadDatiRet: function () {
      this.loading = true
      this.$http.get('sportello/' + this.$store.state.country + '/datiret')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'datiRet', response.body.data[0])
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadFerieRip: function () {
      this.loading = true
      let obj = {
        devengPrec: '',
        devengAtt: '',
        disfrutPrec: '',
        disfrutAtt: '',
        pendienPrec: '',
        pendienAtt: ''
      }
      this.$set(this, 'ferieRip', obj)
      this.$http.get('sportello/' + this.$store.state.country + '/ferierip')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'ferieRip', response.body.data[0])
          }
          this.loading = false
        })
    },
    loadModuli: function () {
      this.$http.get('sportello/' + this.$store.state.country + '/moduli')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'moduli', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    ricModulo: function () {
      let _this = this
      let obj = {
        tipo: this.modulo
      }
      this.loading = true
      this.$confirm(this.$i18n.t('sportello.label.moduli'), this.$i18n.t('sportello.msg.confirmRicModulo'), {
        confirmButtonText: this.$i18n.t('sportello.btn.confirm'),
        cancelButtonText: this.$i18n.t('sportello.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.$http.post('sportello/' + _this.$store.state.country + '/modulo', obj)
              .then(response => {
                if (response.body.rc === 0) {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                } else {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
                _this.loading = false
              })
          }
        }
      })
    },
    copiaResidenza: function () {
      let _this = this
      this.$confirm(this.$i18n.t('sportello.msg.copiaTitle'), this.$i18n.t('sportello.msg.copia'), {
        confirmButtonText: this.$i18n.t('sportello.btn.confirm'),
        cancelButtonText: this.$i18n.t('sportello.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.$set(_this.datiPersVar, 'domLocalita', _this.datiPersVar.resLocalita)
            _this.$set(_this.datiPersVar, 'domIn', _this.datiPersVar.resIn)
            _this.$set(_this.datiPersVar, 'domProv', _this.datiPersVar.resProv)
            _this.$set(_this.datiPersVar, 'domCom', _this.datiPersVar.resCom)
            _this.$set(_this.datiPersVar, 'domCap', _this.datiPersVar.resCap)
          }
        }
      })
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-approved'
        case '1':
          return 'status-send'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.sportello {
  .header-tab {
    height: 80px;
    text-align: center;

    .return {
      margin-top: 10px;
      line-height: 55px;
      height: 45px;
      float: left;
      .set-font(@color: @greenRiva, @weight: bold);

      .fa-icon {
        float: left;
        cursor: pointer;
      }
    }

    .my-label {
      display: block;
      line-height: 55px;
      height: 45px;
      .set-font(@color: @oroRiva, @size: 22px, @weight: bold, @family: 'os-semibolditalic');
      letter-spacing: 2px;
    }

    .my-label-subtitle {
      display: block;
      .set-font(@size: 13px, @weight: normal, @family: 'os-lightitalic');
      height: 25px;
    }

  }

  .el-tabs__content {
    .el-collapse {
      border: none;
    }

    .el-collapse-item__header {
      margin-bottom: 10px;
      //height: 20px;
      //border-bottom: 1px solid #dedede;
      color: @oroRiva;
      font-weight: bold;
      text-align: left;
      //margin-right: 15px;
      text-transform: uppercase;
      letter-spacing: 2px;

      &.is-active {
        border-bottom: 1px solid #dedede;
      }
    }

    .action {
      float: right;
      text-align: right;
      margin-bottom: 10px;
    }
  }

  .tab-sportello {
    height: auto;

    .colonna-md {
      margin-left: 1px;
    }

    .colonna {
      height: 100%;
      margin-top: 20px;

      .blocco {
        padding-bottom: 30px;

        .elemento {
          height: auto;

          .my-area-panel {
            margin-bottom: 10px;
            height: 20px;
            //border-bottom: 1px solid #dedede;
            color: #999;
            font-weight: bold;
            text-align: left;
            //margin-right: 15px;
            text-transform: uppercase;
            letter-spacing: 2px;
          }

          .my-area {
            margin-bottom: 10px;
            height: 20px;
            border-bottom: 1px solid #dedede;
            color: @oroRiva;
            font-weight: bold;
            text-align: left;
            //margin-right: 15px;
            text-transform: uppercase;
            letter-spacing: 2px;
          }

          .sportello-label {
            .set-font(@color: @greenRiva; @size: 13px);
            display: inline;
            text-align: right;
            line-height: 16px;
            height: 22px;
            padding-top: 5px;
            padding-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .sportello-value {
            .set-font(@color: #454848; @size: 12px);
            display: inline;
            text-align: left;
            word-wrap: break-word;
            white-space: normal;
            line-height: 16px;
            min-height: 26px;
            height: 100%;
            border-left: 1px solid @oroRiva;
            padding-top: 5px;
            padding-bottom: 5px;

            .icona {
              color: #54e912;
            }

            .el-input {
              color: @grayMedium;

              &.is-disabled {
                .el-input__inner {
                  border: none;
                }
              }

              .el-input__inner {
                border: none;
                border-bottom: 1px solid #dcdfe6;
                border-radius: 0px;
                height: 22px;
                padding-left: 0px;
                line-height: 0px;
                .set-font(@size: 12px);
                color: @grayMedium;
              }

              .el-input__suffix {
                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }
            }

            .el-date-editor--time {
              width: 150px !important;
            }

            .el-select {
              height: 22px;
              width: 100%;

              .el-input {
                height: 22px;

                .el-input__inner {
                  border: none;
                  border-bottom: 1px solid #dcdfe6;
                  border-radius: 0px;
                  height: 22px !important;
                  padding-left: 0px;
                  .set-font(@size: 12px);
                  color: @grayMedium;

                }
              }
            }

            .el-date-editor {
              width: 100%;

              .el-input__inner {
                padding-left: 30px !important;
              }

              .el-input__prefix {
                left: 0px;

                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }

              .el-input__suffix {
                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }

              &.time {
                width: 100px;
              }
            }
          }

          .my-radio {
            .el-radio__label {
              padding-left: 15px;
              .set-font(@size: 12px);
              color: #454848;
              display: inline;
              text-align: left;
              word-wrap: break-word;
              white-space: normal;
              line-height: 16px;
              min-height: 26px;
              height: 100%;
              padding-top: 5px;
              padding-bottom: 5px;
            }
          }
        }
      }

      .secondo-blocco {
        margin-top: 20px;
      }
    }

    &.inAttesa {
      text-align: center;
      background-color: #e8ddc1;
      height: 40px;
      line-height: 40px;
      font-weight: bold;
    }
  }

  .el-tabs {
    margin-top: 40px;

    .el-tabs__header {
      border-bottom: 1px solid #ccc;
      margin-bottom: 0px;

      .el-tabs__nav-wrap {
        margin-top: 0px;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav {
        border: 0px;
        height: 33px;

        .el-tabs__item {
          text-align: center;
          padding-left: 0px;
          padding-right: 0px;
          border: 0px;
          height: 30px;
          line-height: 30px;
          .set-font(@color: #999);
          letter-spacing: 1px;

          &.is-active {
            .set-font(@weight: bold);

            // background-color: #efe8da;
            .barra {
              background-image: linear-gradient(to right, @oroRiva, @greenRiva);
              height: 3px;
            }
          }
        }

        .el-tabs__item:hover {
          color: @greenRiva;
        }
      }
    }
  }
}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.inoltraBtn {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SportelloDigitale/SportelloES.vue